import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { useAcademyChatActions } from '../../context/AcademyChatActionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const AcademySuggestionButtons = ({
  section,
  stepListLabels,
  disabled
}) => {
  const {
    isStreaming,
    onSuggestionClick,
    trackEvent
  } = useAcademyChatActions();
  const actionLabels = section !== null && section !== void 0 && section.actions ? section.actions.map(a => a.label) : [];
  const labels = stepListLabels !== null && stepListLabels !== void 0 ? stepListLabels : actionLabels;
  if (!labels.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    flexWrap: "wrap",
    gap: "200",
    marginBlockStart: "400",
    children: labels.map(label => /*#__PURE__*/_jsx(Button, {
      use: "secondary",
      size: "extra-small",
      borderRadius: "full",
      disabled: disabled || isStreaming,
      onClick: () => {
        trackEvent('suggestion-clicked');
        onSuggestionClick(label);
      },
      children: label
    }, label))
  });
};